export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const FETCH_CAMPAIGNS = "FETCH_CAMPAIGNS";
export const ORGANIZATION_ERR = "ORGANIZATION_ERR";
export const ORG_CREATE = "ORG_CREATE";
export const ORG_CREATE_ERR = "ORG_CREATE_ERR";
export const ROUTE_CREATE = "ROUTE_CREATE";
export const ROUTE_ERR = "ROUTE_ERR";
export const CAMPAIGN_CREATE = "CAMPAIGN_CREATE";
export const CAMPAIGN_ERR = "CAMPAIGN_ERR";